import PostDetailRoute from "Journal/routes/PostDetailRoute";

export default store => ({
  path: "post",
  childRoutes: [PostDetailRoute(store)],
});
